import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=54d57595&scoped=true&"
import script from "./DashboardContent.vue?vue&type=script&lang=js&"
export * from "./DashboardContent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardContent.vue?vue&type=style&index=0&id=54d57595&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d57595",
  null
  
)

export default component.exports